export default __webpack_public_path__ + "static/media/27M.dff4c32a.jpeg";